/**
 * Application Constants
 * 
 * Centralized constants for API URLs and other configuration.
 * NOTE: Behavior copied from legacy App.js, do not change without regression testing.
 * 
 * @file constants.js
 * @description Contains all constant values used across the application
 */

// Backend API configuration
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
